import ErrorMessage from "components/common/ErrorMessage";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { Select } from "components/common/Select";
import { fetchLanguages } from "slices/languageSlice";
import { languageSelector } from "slices/languageSlice";
import { setError } from "slices/dashboardSlice";
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import FullPageLoader from "components/common/FullPageLoader";
import { fetchMainAccountDashboardAnalytics } from "slices/mainAccount/dashboardSlice";
import { fetchMainAccountDashboardAppointments } from "slices/mainAccount/dashboardSlice";
import { MainAccountDashboardSelector } from "slices/mainAccount/dashboardSlice";
import ListTable from "components/mainAccountAccess/dashboard/ListTable";
import { departmentsSelector } from "slices/departmentsSlice";
import { facilitiesSelector } from "slices/facilitiesSlice";
import { fetchDepartments } from "slices/departmentsSlice";
import { fetchFacilities } from "slices/facilitiesSlice";
import ReactSelect from "react-select";

const DatesInputs = (({ control, errors }) => {
  const startDateRef = React.useRef(null);
  const endDateRef = React.useRef(null);

  return (
    <>
      <div className="row-primary">
        <h2>Start Date*</h2>
        <Controller
          name="start_date"
          control={control}
          render={({ field }) =>
            <div className="input-image">
              <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date'
                {...field}
                value={moment(field.value).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const dateString = moment(new Date(e.target.value)).format('YYYY/MM/DD')
                  field.onChange(dateString)
                }}
              />
              <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

            </div>
          } />
      </div>
      <div className="row-primary">
        <h2>End Date*</h2>
        <Controller
          name="end_date"
          control={control}
          render={({ field }) =>
            <div className="input-image ">
              <input ref={endDateRef} type="date" name='end_date' placeholder='End Date'
                {...field}
                value={moment(field.value).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const dateString = moment(new Date(e.target.value)).format('YYYY/MM/DD')
                  field.onChange(dateString)
                }}
              />
              <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
            </div>
          } />
      </div>
    </>
  )
});

function Dashboard() {
  const dispatch = useDispatch()
  const { mainAccountDashboard: dashboard, last_page: totalPages, loader, total } = useSelector(MainAccountDashboardSelector);
  const { departments } = useSelector(departmentsSelector);
  const { facilities } = useSelector(facilitiesSelector);
  const { language: languages } = useSelector(languageSelector);
  const [filterResetKey, setFilterResetKey] = useState(0);

  const statusOptions = [
    { value: '', label: 'All' },
    { value: 'open', label: 'Open' },
    { value: 'pending', label: 'Pending' },
    { value: 'assigned', label: 'Assigned' },
    // { value: 'active', label: 'Active' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' },
  ];

  const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, reset, } = useForm({
    defaultValues: {
      status: '',
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
    }
  });


  useEffect(() => {
    dispatch(fetchMainAccountDashboardAnalytics());
    dispatch(fetchMainAccountDashboardAppointments(1, { pageLength: 100, start_date: moment().format('YYYY-MM-DD'), end_date: moment().format('YYYY-MM-DD'), sortBy: "datetime", sortDirection: "asc" }));
  }, [])


  // #region Language dropdown 
  const filteredLanguages = React.useMemo(() =>
    languages?.map(language => {
      const object = {
        value: language?.id,
        label: language?.name
      }
      return object
    }), [languages]);

  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true))
    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion

  //#endregion


  const onSubmit = (data) => {
    dispatch(setError({}));
    const payload = {
      ...data,
      sortBy: 'datetime',
      sortDirection: 'asc',
      pageLength: 100,
    };
    dispatch(fetchMainAccountDashboardAppointments(1, payload));
    clearErrors();
  };


  const handleResetFields = () => {
    const defaultValuesReset = {
      status: '',
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      language_id: "",
    };
    reset(defaultValuesReset);
    setFilterResetKey((prev) => prev + 1);
    dispatch(fetchMainAccountDashboardAppointments(1, { pageLength: 100, ...defaultValuesReset, sortBy: "datetime", sortDirection: "asc" }));
    clearErrors();
  };


  const serviceOption = [
    { value: 'In Person', label: 'In Person' },
    { value: 'VRI', label: 'Video Remote Interpretation' },
    { value: 'OPI', label: 'OTP Pre Schedule' },
    { value: 'OPI On Demand', label: 'OPI On Demand' },
  ]

  const [isFourteenDays, setIsFourteenDays] = useState(false);
  const tableRef = useRef(null);

  const handleFilter = (item, isforteen, statusGroup = null) => {
    const today = moment().format('YYYY-MM-DD');
    const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
    const next_fourteen_days = moment().add(14, 'days').format('YYYY-MM-DD');
    if (isforteen === true) {
      setValue("start_date", tomorrow);
      setValue("end_date", next_fourteen_days);
    } else {
      setValue("start_date", today);
      setValue("end_date", today);
    }

    if (item?.value) {
      setValue("service", item?.value);
    } else {
      setValue("service", null);
    }

    const data = {
      start_date: isforteen ? tomorrow : today,
      end_date: isforteen ? next_fourteen_days : today,
      service: item?.value || "",
      sortBy: 'datetime',
      sortDirection: 'asc',
      pageLength: 100,
      ...(statusGroup ? { status_group: statusGroup } : {}),
    };

    dispatch(fetchMainAccountDashboardAppointments(1, data));
    tableRef.current.scrollIntoView({ behavior: "smooth" });
    dispatch(setError({}));
    clearErrors();
  };

  return (
    <>
      <div className="content">
        <div className="row_main_head">
          <h2 className="main_heading">Dashboard</h2>
        </div>

        <div className="row_dash_1">
          <div className="card_table">
            <div className="interpreter p-4">
              <h2>Today</h2>
            </div>

            <div className="Table_data_show pt-0">
              <table>
                <thead>
                  <tr>
                    <th className="col-6">Today</th>
                    <th className="col-3 text-center">Registered</th>
                    <th className="col-3 text-center">To Cover</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard?.analytics?.todays_data?.map((service, index) => (
                    <tr key={index}>
                      <td>{service?.type}</td>
                      <td
                        className="cursorPointer text-center"
                        onClick={() => { setIsFourteenDays(false); handleFilter(service, false, 'registered'); }}
                      >
                        {service?.registered}
                      </td>
                      <td
                        className="cursorPointer text-center"
                        onClick={() => { setIsFourteenDays(false); handleFilter(service, false, 'to_cover'); }}
                      >
                        {service?.to_cover}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card_table">
            <div className="interpreter p-4">
              <h2>Next 14 Days</h2>
            </div>

            <div className="Table_data_show pt-0">
              <table>
                <thead>
                  <tr>
                    <th className="col-6">Today</th>
                    <th className="col-3 text-center">Registered</th>
                    <th className="col-3 text-center">To Cover</th>
                  </tr>
                </thead>
                <tbody>
                  {dashboard?.analytics?.fourteen_days?.map((service, index) => (
                    <tr key={index}>
                      <td>{service?.type}</td>
                      <td
                        className="cursorPointer text-center"
                        onClick={() => { setIsFourteenDays(true); handleFilter(service, true, 'registered'); }}
                      >
                        {service?.registered}
                      </td>
                      <td
                        className="cursorPointer text-center"
                        onClick={() => { setIsFourteenDays(true); handleFilter(service, true, 'to_cover'); }}
                      >
                        {service?.to_cover}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* <ScheduleModal /> */}
        <div className="card_table">
          <form className="search_form_ad">
            <div className="row-primary dahboard_filter">
              <DatesInputs control={control} errors={errors} />
              <div className="row-primary">
                <h2>Status</h2>
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) =>
                    <div className="basic_bases">
                      <ReactSelect
                        menuPlacement="auto"
                        styles={selectCustomStyles}
                        options={statusOptions}
                        value={statusOptions.find(opt => opt.value === field.value) || statusOptions[0]}
                        onChange={(opt) => field.onChange(opt?.value ?? '')}
                        isClearable={false}
                      />
                    </div>
                  }
                />
              </div>
              {/* <div className="row-primary">
                <h2>Language</h2>
                <Controller
                  name="language_id"
                  control={control}
                  render={({ field }) =>
                    <div className="basic_bases">
                      <AsyncPaginate
                        menuPlacement='auto'
                        styles={{
                          ...selectCustomStyles,
                        }}
                        value={field.value ? filteredLanguages?.find((opt) => field.value == opt.value) : ""}
                        loadOptions={filteredLanguagesLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          field.onChange(obj?.value);
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                    </div>
                  }
                />
              </div> */}
            </div>

            <div className="row-primary btns_area row_10">
              <SubmitButton handleSubmit={handleSubmit(onSubmit)} buttonType="button" btnText="Search" className={'green'} />
              <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reset" handleSubmit={handleResetFields} />
            </div>

            <div ref={tableRef}>
              <ListTable
                data={dashboard?.appointments}
                resetKey={filterResetKey}
                filterParams={{
                  status: watch('status') || '',
                  start_date: moment(watch('start_date')).format('YYYY-MM-DD'),
                  end_date: moment(watch('end_date')).format('YYYY-MM-DD'),
                  language_id: watch('language_id') || '',
                }}
              />
            </div>

          </form>
        </div>
      </div>

      {loader && <FullPageLoader />}
    </>
  );
}

export default Dashboard;